var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMountain2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1218,
    height: 465,
    viewBox: "0 0 1218 465",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1102.58 107.458C1147.47 78.2477 1338.52 68.1323 1356.02 80.303V464.757H0.102051C40.9577 421.033 138.59 283.123 227.295 268.339C276.173 260.193 281.604 181.157 330.482 159.618C407.42 125.714 435.48 145.274 472.591 107.458C509.702 69.6412 532.331 89.2014 563.106 77.4653C593.881 65.7292 600.217 37.0408 614.7 13.5687C629.182 -9.90348 638.234 3.13657 647.285 13.5687C656.337 24.0008 654.526 -0.775467 662.673 13.5687C670.819 27.9128 740.516 72.2492 754.998 77.4653C769.481 82.6813 783.963 107.458 812.023 89.2014C840.082 70.9451 825.6 83.9853 907.064 136.146C988.527 188.306 1046.46 143.97 1102.58 107.458Z",
    fill: "url(#paint0_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(314.098 570.606) rotate(-16.6402) scale(846.92 486.447)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E754A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538286,
    stopColor: "#E0848D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B4AB8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountain2);
export default __webpack_public_path__ + "static/media/mountain2.9a5bf067b6e2ae84de7dc91275c0d868.svg";
export { ForwardRef as ReactComponent };